import { Either, left, right } from 'src/utils/either';

import { HttpTypes } from '.';
import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  InternalServerError,
  NotFoundError,
  TooManyRequestsError,
  UnexpectedError,
} from './errors';

export const httpResponseHandler = <T>(response: HttpTypes.HttpResponse): Either<Error, T> => {
  switch (response.statusCode) {
    case HttpTypes.HttpStatusCode.ok:
    case HttpTypes.HttpStatusCode.created: {
      return right(response.body);
    }
    case HttpTypes.HttpStatusCode.badRequest: {
      return left(new BadRequestError(response.body));
    }
    case HttpTypes.HttpStatusCode.unauthorized: {
      return left(new AccessDeniedError());
    }
    case HttpTypes.HttpStatusCode.connection: {
      return left(new ConnectionError());
    }
    case HttpTypes.HttpStatusCode.tooManyRequests: {
      return left(new TooManyRequestsError());
    }
    case HttpTypes.HttpStatusCode.notFound: {
      return left(new NotFoundError(response.body));
    }
    case HttpTypes.HttpStatusCode.serverError: {
      return left(new InternalServerError());
    }
    case HttpTypes.HttpStatusCode.conflict: {
      return left(new BadRequestError(response.body));
    }
    default: {
      return left(new UnexpectedError(response.statusCode));
    }
  }
};
